export default [
    function () {
        return {
            restrict: 'E',
            template: require('./nonBlockingSpinner.html'),
        };
    },
];
